import { render, staticRenderFns } from "./ImageZone.vue?vue&type=template&id=10c40ee2&scoped=true&"
import script from "./ImageZone.vue?vue&type=script&lang=js&"
export * from "./ImageZone.vue?vue&type=script&lang=js&"
import style0 from "./ImageZone.vue?vue&type=style&index=0&id=10c40ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c40ee2",
  null
  
)

export default component.exports